import React from 'react';
import { ADD_TRIGGER, TRIGGER } from 'src/views/shared/Process/constants';
import BaseDrawer from '../ManagePerspective/Inspectors/BaseDrawer';
import ManageAction from './ManageAction';
import ManageTrigger from './ManageTrigger';
import { WorkflowWithStepsAndEdges } from '../../../../types';


interface Props {
  workflowId: string,
  workflow: WorkflowWithStepsAndEdges,
  selectedElementId?: string,
  refreshWorkflow: () => void,
  selectedElement?: any,
  selectedElementIncomers: any[],
  selectedElementOutgoers: any[],
}

const RightDrawer = ({
  workflow,
  workflowId,
  selectedElement,
  selectedElementIncomers,
  selectedElementOutgoers,
  refreshWorkflow,
}: Props) => {
  if (!selectedElement) return null;

  return (
    <BaseDrawer>
      {
        [TRIGGER, ADD_TRIGGER].includes(selectedElement.type) ? (
          <ManageTrigger
            workflowId={workflowId}
            selectedElement={selectedElement}
            selectedElementOutgoers={selectedElementOutgoers}
            refreshWorkflow={refreshWorkflow}
          />
        ) : (
          <ManageAction
            workflow={workflow}
            workflowId={workflowId}
            selectedElement={selectedElement}
            selectedElementIncomers={selectedElementIncomers}
            selectedElementOutgoers={selectedElementOutgoers}
            refreshWorkflow={refreshWorkflow}
          />
        )
      }
    </BaseDrawer>
  );
};

export default RightDrawer;
